import { render, staticRenderFns } from "./AppIconButton.vue?vue&type=template&id=4ed4aa70&scoped=true&"
import script from "./AppIconButton.vue?vue&type=script&lang=js&"
export * from "./AppIconButton.vue?vue&type=script&lang=js&"
import style0 from "./AppIconButton.vue?vue&type=style&index=0&id=4ed4aa70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed4aa70",
  null
  
)

export default component.exports